/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ForgotPasswordAliases {
  ACTIONS_PANEL = 'actions-panel',
  CONFIRM_BUTTON = 'confirm-button',
  CONTENT_LAYOUT = 'content-layout',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  EMAIL_FIELD = 'email-field',
  EMAIL_INPUT = 'email-input',
  MAIN_TOAST = 'main-toast',
  PANEL_TOAST_INLINE = 'panel-toast-inline',
  RESET_PASSWORD_FORM = 'reset-password-form',
  ROOT_LAYOUT = 'root-layout',
  ROOT_MODAL = 'root-modal',
  SUBTITLE_PANEL = 'subtitle-panel',
  SUBTITLE_TEXT = 'subtitle-text',
  TOAST_NOTIFICATION_INFORMATION = 'toast-notification-information',
}
export { ForgotPasswordAliases };
